<template>
  <div class="container">
    <van-field v-model="myTicket" rows="3" autosize label="ticket" type="textarea" maxlength="540"
      placeholder="ticket" show-word-limit />
    <van-field v-model="fileUrl_1" rows="3" autosize label="第一个文件地址" type="textarea" maxlength="540"
      placeholder="请输入第一个文件的地址" show-word-limit />
      <van-field v-model="fileSize_1" label="第一个大小"
      placeholder="请输入第一个文件的大小" />
    <van-button @click="viewFile_1" size="small" plain type="primary">
      查看第一个文件
    </van-button>
    <van-divider />
    <van-field v-model="fileUrl_2" rows="3" autosize label="第二个文件地址" type="textarea" maxlength="540"
      placeholder="请输入第二个文件的地址" show-word-limit />
      <van-field v-model="fileSize_2" label="第一个大小"
      placeholder="请输入第二个文件的大小" />
    <van-button @click="viewFile_2" size="small" plain type="primary">
      查看第二个文件
    </van-button>
  </div>
</template>
<script>
import{ getTicket } from '@/api/file.js';
import * as ww from '@wecom/jssdk'
export default {
  data() {
    return {
      fileUrl_1: 'https://xc.nmgheli.com/profile/xcyth/upload/2024/03/27/taskFeedback/9fc570feec244320b79a5be7840d74b5_房产平台项目周报（2024年03月18-2023年03月22日).pdf',
      fileSize_1: 115619,
      fileUrl_2: 'https://xc.nmgheli.com/profile/xcyth/upload/2024/03/27/taskFeedback/844bee75987443c69739d3f19909a2d7_房产平台项目周报（2024年03月18-2023年03月22日).docx',
      fileSize_2: '22405',
      corpId : 'ww5b7b6b536dc90edd',
      jsSdkApiArr: ['previewFile'],
      myTicket: 'HoagFKDcsGMVCIY2vOjf9vYJoyLC9vRMMTg4gnXH0N9OMzJtv7iCbDcBfbvNtcbS8N_U7PBpFGEp2SK219vqoA',
    };
  },
  created() {
    this.registerWw(this.corpId, this.jsSdkApiArr);
  },
  methods: {
    registerWw(corpId,jsSdkArr) {
      return new Promise((success, err) => {
        getTicket().then(res => {
          ww.register({
            corpId: corpId,
            jsApiList: jsSdkArr,
            getConfigSignature() {
              return ww.getSignature(res.ticket)
            }
          })
        }).catch(e=>{
          console.error('后台获取ticket数据失败:',e)
        });
      });
    },
    viewFile_2() {
      let that = this;
      ww.previewFile({
			  url: that.fileUrl_2,
			  size: that.fileSize_2,
        success(result) {
          // 成功回调，result.errMsg 固定格式为“方法名:ok”
          console.log("调用成功",result);
        },
        fail(result) {
          // 失败回调，通过 result.errMsg 查看失败详情
          console.log("调用失败",result);
        },
        complete(result) {
          // 完成回调，无论调用成功还是失败，都会回调该方法
          console.log("调用完成",result);
        }
			})
    },
    viewFile_1() {
      let that = this;
      ww.previewFile({
			  url: that.fileUrl_1,
			  size: that.fileSize_1
			})
    }
  }
};
</script>
<style scoped></style>
